import styled from "styled-components";

export const PanelWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--accent);
`;

export const LockedHint = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-muted);
`;

export const RoleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
`;

export const RoleCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px;
  background: var(--surface-2);
`;

export const RoleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .role-name {
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--text);
  }
`;

export const RoleBadge = styled.span<{ $signed?: boolean }>`
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 999px;
  color: ${(p) => (p.$signed ? "#0f5132" : "#842029")};
  background: ${(p) => (p.$signed ? "#d1e7dd" : "#f8d7da")};
`;

export const SignedPreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  .ink {
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: #ffffff;
    padding: 8px;
  }

  .ink img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .who {
    font-size: 0.85rem;
    color: var(--text);
  }

  .meta {
    font-size: 0.72rem;
    color: var(--text-muted);
  }
`;

export const PadError = styled.span`
  font-size: 0.75rem;
  color: #d32f2f;
`;

export const PadActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
`;

export const SelectedBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  background: var(--surface-2);

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .info strong {
    font-size: 0.95rem;
  }

  .info small {
    color: var(--text-muted);
  }
`;

export const SignatureFlags = styled.div`
  display: flex;
  gap: 6px;
`;
